var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"change-contacts-form"},[_c('p',{staticClass:"text-small text-secondary mb-4"},[_vm._v(" To change your contacts, you’ll need your current telephone and email for confirming the action. ")]),_c('AccountPhoneNumberChange',{staticClass:"mb-4"}),_c('AccountEmailChange',{staticClass:"mb-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }